import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from "../../base-form.component";
import { GlobalConfig } from 'app/models/global-config.model';
import { TranslateService } from '@ngx-translate/core';
import { CompanyService } from 'app/services/company.service';
import { GlobalConfigCashEnum, GlobalConfigDistanceEnum, GlobalConfigFuelEnum } from 'app/models/global-config.enum';


@Component({
    selector: 'global-config-form',
    templateUrl: './global-config-form.component.html',
    styleUrls: ['./global-config-form.component.scss']
})
export class GlobalConfigFormComponent extends BaseFormComponent implements OnInit {

    public get globalConfigFuelEnum(){
        return GlobalConfigFuelEnum;
    }

    public get globalConfigCashEnum(){
        return GlobalConfigCashEnum;
    }

    public get globalConfigDistanceEnum(){
        return GlobalConfigDistanceEnum;
    }

    private _model: GlobalConfig;
    public get model(): GlobalConfig {
        return this._model;
    }
    public set model(v: GlobalConfig) {
        this._model = v;
    }


    constructor(
        private _httpClient: HttpClient,
        private _toasterService: ToasterService,
        private _companyService: CompanyService,
        private _translateService: TranslateService,
        private appConfigService: AppInitializationService,
    ) {
        super();
    }


    public async ngOnInit() {

    }

    public async save() {
        
        if (!this.form.valid) {
            this._toasterService.toastWarning(this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY"))
            return;
        }

        if (this.operation == "create") {
            var globalConfig = await this.create();
            this.added.emit(globalConfig)
        }
        else {
            var globalConfig = await this.update();
            this.updated.emit(globalConfig);
        }
    }

    public async create(): Promise<GlobalConfig> {
        try {
            debugger;
            var globalConfig = await this._companyService.addGlobalConfig(this.model)
            return globalConfig;
        } catch (error) {
            this._toasterService.toastFail()
            console.warn(error);
            return;
        }
    }

    public async update(): Promise<GlobalConfig> {
        try {
            debugger;
            var globalConfig = await this._companyService.updatedGlobalConfig(this.model)
            return globalConfig;
            
        } catch (error) {
            this._toasterService.toastFail()
            console.warn(error);
            return;
        }
    }


}
